export default {
    name:'accordion-group',
    data() {
        return {
            currentSel: -10
        }
    },
    methods: {
        onSelectItem(e) {
            if (e === this.currentSel) {
                this.currentSel = -10
            } else {
                this.currentSel = e
            }
        },
        agBeforeEnter(e) {
          e.style.display = 'block'
          e.style.maxHeight = null
          e.myHeight = e.offsetHeight
          e.style.display = null
        },
        agOnEnter(e) {
          e.style.maxHeight = 'max-content'
        }
    }
}
